const AchievementData = [
    { year: 2017, title: 'Festival Teater Pelajar 2017 tingkat Kabupaten Banjarnegara (Juara I)' },
    { year: 2018, title: 'FLS2N 2018 tingkat Provinsi Jawa Tengah (Juara II)' },
    { year: 2019, title: 'Artefac UNS 2019 tingkat Nasional (6 Besar)' },
    { year: 2020, title: 'Artefac UNS 2020 tingkat Nasional (Penyaji Artistik Terbaik)' },
    { year: 2022, title: 'Artefac UNS 2022 tingkat nasional (Penyaji Terbaik II)' },
    { year: 2023, title: 'Artefac UNS 2023 tingkat nasional (Penyaji Terbaik III)' },
    { year: 2023, title: 'FLS2N SMA 2023 Cabang Lomba Baca Puisi tingkat Provinsi (Juara III)' },
    { year: 2024, title: 'FLS2N SMA 2024 Cabang Lomba Monolog tingkat Kabupaten Banjarnegara (Juara I)' },
    { year: 2024, title: 'FLS2N SMA 2024 Cabang Lomba Baca Puisi tingkat Kabupaten Banjarnegara (Juara III)' },
    {year: 2024, title: 'Penghargaan Tergiat 2 oleh Komunitas Teater Bara (Teater Banjarnegara) masa kepengurusan 2024/2025'},
    {year: 2025, title: 'Artefac UNS 2025 tingkat Nasional (Penyaji Terbaik 5)'},
    {year: 2025, title: 'FLS3N SMA/SMK/MA Cabang Lomba Monolog tingkat kabupaten Banjarnegara (Juara II)'},
    {year: 2025, title: 'FLS3N SMA/SMK/MA Cabang Lomba Vocal Solo Putra tingkat kabupaten Banjarnegara (Juara I)'},
    {year: 2025, title: 'FLS3N SMA/SMK/MA Cabang Lomba Vocal Solo Putra tingkat Cabang Dinas Wilayah IX (Juara III)'},
]

export default AchievementData;